import classNames from 'classnames';
import useWorldTheme from 'hooks/shared/useWorldTheme';
import type { FC } from 'react';

const theme: Record<string, string> = {
  expenses: 'bg-expenses-200 !text-expenses',
  revenues: 'bg-revenues-200 !text-revenues',
  taxes: 'bg-taxes-200 !text-taxes',
  bank: 'bg-bank-200 !text-bank',
  primary: 'bg-primary-200 !text-primary',
};

export const Count: FC<{ count: string | number; className?: string }> = ({
  count,
  className,
}) => {
  const world = useWorldTheme();

  return (
    <span
      className={classNames(
        className,
        'w-[1.15rem] h-[1.15rem] rounded-full text-white flex items-center justify-center text-xs font-semibold',
        theme[String(world)],
      )}
    >
      {count}
    </span>
  );
};
